import axios from "axios";
import env from "../variables/EndpointEnvironment";

const DividenAPI = () => {
  return axios.get(`${env.HOST}/dividen`, {
    headers: {
      "Content-Language": localStorage.getItem('i18nextLng'),
    },
  });
};

export default DividenAPI;
